import { jsx as s, jsxs as a } from "react/jsx-runtime";
import { c as r } from "../../index-C7ezJk5b.js";
import { useMemo as f } from "react";
import { Link as b } from "react-router-dom";
import { b as S } from "../../base-nYmjnkiN.js";
import { useIsInternalForApp as g } from "../../core/hooks/useIsInternalForApp.js";
import { capitalize as m } from "../../core/utils/string.js";
import { cssX as o, cssTI as l } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import C from "./GlobalSearchResultsItem.js";
const F = ({
  data: e,
  columnsCount: c = 1,
  placeholder: p,
  children: n
}) => {
  const i = g(e.internalForApp), {
    globalSearch: u
  } = S(), h = f(
    () => {
      const t = {
        className: r(o("GlobalSearchResultCategory__more")),
        "data-testid": l("button", `SearchPopupGroupResult${m(e.title, !0)}`),
        children: "more",
        onClick: () => {
          u.setIsOpened(!1);
        }
      };
      return !e.moreResultsUrl || !e.moreResultsPath ? null : i ? /* @__PURE__ */ s(b, { to: e.moreResultsPath, ...t }) : /* @__PURE__ */ s("a", { href: e.moreResultsUrl, ...t });
    },
    [i, e.moreResultsUrl, e.moreResultsPath, u]
  );
  return /* @__PURE__ */ a("div", { className: r(o("GlobalSearchResultCategory")), children: [
    /* @__PURE__ */ a("div", { className: r(o("GlobalSearchResultCategory__header")), children: [
      /* @__PURE__ */ s(
        "div",
        {
          className: r(o("GlobalSearchResultCategory__title")),
          "data-testid": l("label", `SearchPopupCategoryTitle${m(e.title, !0)}`),
          children: e.title
        }
      ),
      h
    ] }),
    /* @__PURE__ */ a(
      "div",
      {
        className: r(
          o("GlobalSearchResultCategory__body"),
          `col-${c}`
        ),
        "data-testid": l("select", `SearchPopupCategoryResults${m(e.title, !0)}`),
        children: [
          e.items.length === 0 && p,
          e.items.map((t, R) => /* @__PURE__ */ s(
            C,
            {
              data: t,
              testId: l("button", `SearchPopupCategoryResult${R}`)
            },
            t.id
          ))
        ]
      }
    ),
    n
  ] });
};
export {
  F as default
};
